import * as Yup from 'yup';
import 'yup-phone';


export enum ORDERS {
  PIPE = 1,
  WAVE = 2
}



export interface IUserStatusMsg {
  danger: string,
  success: string,
  update: string,
}

export const TYPES_ORDER: Record<string, number> = {
  WAVE: ORDERS.WAVE,
  PIPE: ORDERS.PIPE
}

export const MODAL_USER_PANELS = {
  data: 'data',
  address: 'address',
  documents: 'documents',
  payOrder: 'payOrder',
  statistics: 'statistics',
  certificates: 'certificates',
  deposits: 'deposits',
} as const

export const FETCHER_STATUS = {
  loading: 'loading',
  failed: 'failed',
  loaded: 'loaded',
};

export const validationSchemaModalPhoneCall = Yup.object().shape({
  phone: Yup.string().phone('', true, 'Неккоректный телефон').required('Необходимо указать телефон!'),
});

export const ATC_TYPE: Record<string, any> = {
  OUTGOING: 'Вызов',
  INCOMING: 'Звонок',
  ACCEPTED: 'Идет разговор',
  DEFAULT: 'Набор',
};

export enum TYPES_DEPOSITS {
  MONEY,
  PIPE,
  WAVE
}

export enum ARR_TYPE {
  deposit_money,
  minute_deposits,
  set_deposits,
}

export enum ARR_DEPOSITS_TYPE {
  money_deposits,
  tube_deposits,
  wave_deposits
}

export const TITLE_DEPOSIT_NUll:Record<string, any> = {
  [TYPES_DEPOSITS.MONEY]: 'Денежные',
  [TYPES_DEPOSITS.PIPE]: 'Минутные',
  [TYPES_DEPOSITS.WAVE]: 'Сетовые',
}

export enum TYPE_USER {
  SUPERUSER = 'superuser',
  STAFF = 'staff',
  VIEWER = 'viewer'
}

export enum NOTIFICATION_TYPE {
  NEW_TASK = 0,
  TASK_REMINDER = 1
}

export enum CHECK_TYPE {
  DEPOSIT = 0,
  CERTIFICATE = 1
}